import { useNavigate } from "react-router-dom";

const Admin = ({ isToggled, toggleSidebar }: { isToggled?: boolean, toggleSidebar?: () => void }) => {
  const navigate = useNavigate();

  const items = [
    {
      name: 'Dashboard',
      navigateTo: '',
      icon: 'fa-chart-pie',
      color: '#4e73df',
      bgColor: '#eaecf4'
    },
    {
      name: 'Customers',
      navigateTo: 'customer',
      icon: 'fa-users',
      color: '#1cc88a',
      bgColor: '#e3fbe3'
    },
    {
      name: 'Properties',
      navigateTo: 'property',
      icon: 'fa-home',
      color: '#36b9cc',
      bgColor: '#e2f6f9'
    },
    {
      name: 'Banners',
      navigateTo: 'custom-ad',
      icon: 'fa-image',
      color: '#f6c23e',
      bgColor: '#fdf6e3'
    },
    {
      name: 'Leads / Appointments',
      navigateTo: 'appointments',
      icon: 'fa-calendar-check',
      color: '#e74a3b',
      bgColor: '#fceceb'
    },
  ];

  return (
    <ul
      className={`navbar-nav bg-primary sidebar sidebar-dark accordion ${isToggled ? 'toggled' : ''}`}
      id="accordionSidebar"
    >
      {/* Sidebar - Brand */}
      <div className="sidebar-brand d-flex align-items-center justify-content-between px-3 w-100" style={{ height: '4.375rem' }}>
        <a className="d-flex align-items-center justify-content-center text-white text-decoration-none" href="index.html">
          <div className="sidebar-brand-icon rotate-n-15">
            <i className="fas fa-laugh-wink"></i>
          </div>
          <div className="sidebar-brand-text mx-3">Cirayedaar</div>
        </a>
        {toggleSidebar && (
          <button className="btn btn-link text-white d-md-none p-0 border-0" onClick={toggleSidebar}>
            <i className="fas fa-times fa-lg"></i>
          </button>
        )}
      </div>

      <hr className="sidebar-divider my-0 d-none d-md-block" />

      {/* Mobile Title - Only visible on small screens */}
      <div className="mobile-title px-4 pt-2 pb-4">
        <h2 className="fw-bolder mb-2" style={{ color: '#1a202c', fontSize: '1.8rem' }}>How can we help?</h2>
        <p className="text-muted" style={{ fontSize: '0.95rem', lineHeight: '1.4' }}>
          Select an option below to manage the platform and view insights.
        </p>
      </div>

      <li className="nav-item active w-100">
        {
          items.map(item => (
            <button
              key={item.name}
              type="button"
              className="nav-link collapsed mobile-grid-btn"
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer'
              }}
              onClick={() => {
                navigate(`/${item.navigateTo}`);
                if (window.innerWidth <= 768 && toggleSidebar) {
                  toggleSidebar();
                }
              }}
            >
              <div className="icon-wrapper" style={{ color: item.color, backgroundColor: item.bgColor }}>
                <i className={`fas fa-fw ${item.icon}`}></i>
              </div>
              <span>{item.name}</span>
            </button>
          ))
        }
      </li>

      <hr className="sidebar-divider d-none d-md-block" />

      <div className="text-center d-none d-md-inline">
        <button className="rounded-circle border-0" onClick={toggleSidebar}></button>
      </div>
    </ul>
  );
};

export default Admin;
